<template>
  <component
    :is="element"
    :class="[textClass, textColorClass, lineHeight]"
    class="mb-0"
  >
    <span
      class="px-8 py-4 hyphens-auto box-decoration-clone"
      :class="[boxColorClass]"
    >
      <slot></slot>
    </span>
  </component>
</template>

<script lang="ts" setup>
interface Props {
  boxColorClass?: string;
  lineHeight?: string;
  element?:
    | 'p'
    | 'a'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'label'
    | 'span';

  textClass?:
    | 'body-md'
    | 'body-bold-md'
    | 'body-sm'
    | 'body-link-sm'
    | 'body-link-md'
    | 'heading-xl'
    | 'heading-lg'
    | 'heading-md'
    | 'heading-sm'
    | 'heading-xs'
    | 'heading-xxs';
  textColorClass?: string;
}

withDefaults(defineProps<Props>(), {
  boxColorClass: 'bg-surface-primary',
  element: 'span',
  lineHeight: 'leading-[120%]',
  textClass: undefined,
  textColorClass: 'text-text-primary',
});
</script>

<style scoped lang="scss"></style>
